const timeOptions = [
  { id: 6, name: 'Last week' },
  { id: 13, name: 'Last 2 weeks' },
  { id: 30, name: 'Last month' }
];

export { timeOptions };
